var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "list",
      staticClass: "infinite-list-container",
      style: { height: _vm.height },
      attrs: { id: `${_vm.idName}_IconSelectConfiguration` },
      on: {
        scroll: function ($event) {
          return _vm.scrollEvent($event)
        },
      },
    },
    [
      _c("div", { ref: "phantom", staticClass: "infinite-list-phantom" }),
      _c(
        "div",
        { ref: "content", staticClass: "infinite-list" },
        _vm._l(_vm.visibleData, function (item) {
          return _c(
            "div",
            {
              key: item._index,
              ref: `${_vm.idName}items`,
              refInFor: true,
              staticClass: "infinite-list-item",
              attrs: { id: item._index },
            },
            [
              _vm._t("default", null, {
                item: item.item,
                index: Number(item._index.split("_")[1]),
              }),
            ],
            2
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }